// ImageLoader.js - פונקציות טעינת תמונות לפרויקטים של לילך

// מיפוי סיומות לפי פרויקט
const extensionMap = {
  "לילך מורד גן יבנה": "webp",
  "הדמיות משרד אדל": "webp",
  "משרדי אדל סופיות": "webp",
  "הדמיות פרוייקט אשדוד": "webp",
  "הדמיות פרוייקט ירוחם": "webp",
  "פילאטיס": "webp",
};

// ירוחם: כל התמונות עכשיו webp
const getYerochamExtension = (index) => {
  return "webp";
};

/**
 * טוען thumbnail לפרויקט
 */
export const loadThumbnail = async (folderName, thumbnailIndex = 1) => {
  const extensions =
    folderName === "הדמיות פרוייקט ירוחם"
      ? [getYerochamExtension(thumbnailIndex), "webp", "jpg", "JPG", "png", "PNG"]
      : [extensionMap[folderName] || "webp", "webp", "jpg", "JPG", "png", "PNG", "jpeg"];

  for (const ext of extensions) {
    try {
      const image = await import(
        `../../images/${folderName} ${thumbnailIndex}.${ext}`
      );
      return image.default;
    } catch (e) {
      continue;
    }
  }

  console.error(`Failed to load thumbnail for ${folderName}`);
  throw new Error(`Could not load thumbnail for ${folderName}`);
};

/**
 * טוען את כל התמונות של פרויקט
 */
export const loadProjectGallery = async (folderName, imageCount, excludeRange) => {
  const gallery = [];

  for (let i = 1; i <= imageCount; i++) {
    if (excludeRange && i >= excludeRange[0] && i <= excludeRange[1]) continue;
    const extensions =
      folderName === "הדמיות פרוייקט ירוחם"
        ? [getYerochamExtension(i), "webp", "jpg", "JPG", "png", "PNG"]
        : [extensionMap[folderName] || "webp", "webp", "jpg", "JPG", "png", "PNG", "jpeg"];

    let loaded = false;
    for (const ext of extensions) {
      try {
        const image = await import(`../../images/${folderName} ${i}.${ext}`);
        gallery.push(image.default);
        loaded = true;
        break;
      } catch (e) {
        continue;
      }
    }

    if (!loaded) {
      console.warn(`Could not load image ${i} for ${folderName}`);
    }
  }

  return gallery;
};

/**
 * טוען תמונות עם תגיות (tagged images) - מחזיר מערך של { src, tag }
 */
export const loadTaggedImages = async (taggedConfig) => {
  if (!taggedConfig) return [];
  const { folderName, imageCount, extension, tag } = taggedConfig;
  const tagged = [];

  for (let i = 1; i <= imageCount; i++) {
    const extensions = [extension, "webp", "jpg", "JPG", "png", "PNG"];
    for (const ext of extensions) {
      try {
        const image = await import(`../../images/${folderName} ${i}.${ext}`);
        tagged.push({ src: image.default, tag });
        break;
      } catch (e) {
        continue;
      }
    }
  }

  return tagged;
};
